import { Col, Form, Input, Radio, Row } from 'antd';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TitleBox from 'src/components/title-box/title-box';
import { BORROWER_CREDIT_VALUE } from 'src/constants';
import { scrollPageToTop } from 'src/helpers/window';
import useStore from 'src/hooks/useStore';

import { i18nKey } from 'src/locales/i18n';
import { ICorporateOnboardingStore } from 'src/store/corporate/onboarding.store';
import styles from './other-detail.module.less';

const CorporateBorrowerOtherDetail: FC = () => {
	const [t] = useTranslation();

	const yesNoOptions = [
		{
			label: t(i18nKey.common.yes),
			value: BORROWER_CREDIT_VALUE.YES
		},
		{
			label: t(i18nKey.common.no),
			value: BORROWER_CREDIT_VALUE.NO
		}
	];
	const onboardStore: ICorporateOnboardingStore = useStore('corporateOnboardingStore');
	const [form] = Form.useForm();

	useEffect(() => {
		scrollPageToTop();
	}, []);

	useEffect(() => {
		if (!form.isFieldsTouched()) {
			form.setFieldsValue({
				...onboardStore.onboardingOtherDetail
			});
		}
	}, [onboardStore.onboardingOtherDetail]);
	return (
		<>
			<TitleBox>
				<span>{t(i18nKey.onboarding.request.otherDetails.corporate.title)}</span>
			</TitleBox>
			<Form
				form={form}
				layout="vertical"
				disabled
				initialValues={{
					...onboardStore.onboardingOtherDetail
				}}>
				<div className={styles.subForm}>
					<Row>
						<Col span={24} className={styles.questionBox}>
							<Row align={'middle'}>
								<Col xs={19} sm={19} md={19} lg={20}>
									<span className={styles.questionText}>
										{t(i18nKey.onboarding.request.otherDetails.corporate.question1)}
									</span>
								</Col>
								<Col xs={5} sm={5} md={5} lg={4}>
									<Form.Item
										name={['questions', 'question1', 'value']}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Radio.Group options={yesNoOptions} />
									</Form.Item>
								</Col>
							</Row>
							{onboardStore.onboardingOtherDetail?.questions?.question1?.value === BORROWER_CREDIT_VALUE.YES && (
								<Row>
									<Col span={24}>
										<Form.Item
											name={['questions', 'question1', 'detail']}
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}>
											<Input.TextArea
												style={{ height: 140, resize: 'none' }}
												placeholder={`${t(
													i18nKey.onboarding.request.otherDetails.individual.otherFill
												)}`}></Input.TextArea>
										</Form.Item>
									</Col>
								</Row>
							)}
							<Row align={'middle'}>
								<Col xs={19} sm={19} md={19} lg={20}>
									<span className={styles.questionText}>
										{t(i18nKey.onboarding.request.otherDetails.corporate.question2)}
									</span>
								</Col>
								<Col xs={5} sm={5} md={5} lg={4}>
									<Form.Item
										name={['questions', 'question2', 'value']}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Radio.Group options={yesNoOptions} />
									</Form.Item>
								</Col>
							</Row>
							{onboardStore.onboardingOtherDetail?.questions?.question2?.value === BORROWER_CREDIT_VALUE.YES && (
								<Row>
									<Col span={24}>
										<Form.Item
											name={['questions', 'question2', 'detail']}
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}>
											<Input.TextArea
												style={{ height: 140, resize: 'none' }}
												placeholder={`${t(
													i18nKey.onboarding.request.otherDetails.individual.otherFill
												)}`}></Input.TextArea>
										</Form.Item>
									</Col>
								</Row>
							)}

							<Row align={'middle'}>
								<Col xs={19} sm={19} md={19} lg={20}>
									<span className={styles.questionText}>
										{t(i18nKey.onboarding.request.otherDetails.corporate.question3)}
									</span>
								</Col>
								<Col xs={5} sm={5} md={5} lg={4}>
									<Form.Item
										name={['questions', 'question3', 'value']}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Radio.Group options={yesNoOptions} />
									</Form.Item>
								</Col>
							</Row>
							{onboardStore.onboardingOtherDetail?.questions?.question3?.value === BORROWER_CREDIT_VALUE.YES && (
								<Row>
									<Col span={24}>
										<Form.Item
											name={['questions', 'question3', 'detail']}
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}>
											<Input.TextArea
												style={{ height: 140, resize: 'none' }}
												placeholder={`${t(
													i18nKey.onboarding.request.otherDetails.individual.otherFill
												)}`}></Input.TextArea>
										</Form.Item>
									</Col>
								</Row>
							)}

							<Row align={'middle'}>
								<Col xs={19} sm={19} md={19} lg={20}>
									<span className={styles.questionText}>
										{t(i18nKey.onboarding.request.otherDetails.corporate.question4)}
									</span>
								</Col>
								<Col xs={5} sm={5} md={5} lg={4}>
									<Form.Item
										name={['questions', 'question4', 'value']}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Radio.Group options={yesNoOptions} />
									</Form.Item>
								</Col>
							</Row>
							{onboardStore.onboardingOtherDetail?.questions?.question4?.value === BORROWER_CREDIT_VALUE.YES && (
								<Row>
									<Col span={24}>
										<Form.Item
											name={['questions', 'question4', 'detail']}
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}>
											<Input.TextArea
												style={{ height: 140, resize: 'none' }}
												placeholder={`${t(
													i18nKey.onboarding.request.otherDetails.individual.otherFill
												)}`}></Input.TextArea>
										</Form.Item>
									</Col>
								</Row>
							)}

							<Row align={'middle'}>
								<Col xs={19} sm={19} md={19} lg={20}>
									<span className={styles.questionText}>
										{t(i18nKey.onboarding.request.otherDetails.corporate.question5)}
									</span>
								</Col>
								<Col xs={5} sm={5} md={5} lg={4}>
									<Form.Item
										name={['questions', 'question5', 'value']}
										rules={[
											{
												required: true,
												message: `${t(i18nKey.onboarding.validation.required)}`
											}
										]}>
										<Radio.Group options={yesNoOptions} />
									</Form.Item>
								</Col>
							</Row>
							{onboardStore.onboardingOtherDetail?.questions?.question5?.value === BORROWER_CREDIT_VALUE.YES && (
								<Row>
									<Col span={24}>
										<Form.Item
											name={['questions', 'question5', 'detail']}
											rules={[
												{
													required: true,
													message: `${t(i18nKey.onboarding.validation.required)}`
												}
											]}>
											<Input.TextArea
												style={{ height: 140, resize: 'none' }}
												placeholder={`${t(
													i18nKey.onboarding.request.otherDetails.individual.otherFill
												)}`}></Input.TextArea>
										</Form.Item>
									</Col>
								</Row>
							)}
						</Col>
					</Row>
				</div>
			</Form>
		</>
	);
};
export default CorporateBorrowerOtherDetail;
